import React, { useState } from "react";
import TransferHome from "./TransferHome";
import Beneficiary from "./Beneficiary";
import TransferHistory from "./TransferHistory";
import NewAccount from "./NewAccount";
import styles from "./transfer.module.css";
import { MoneyCard } from "Components/shared/cards/MoneyCard";
import { Outlet } from "react-router-dom";
import Text from "Components/shared/text";
import Hidden from "Components/shared/hidden";
import { Header } from "Components/header/Header";
import { useGetWalletBalance } from "services/walletService";
import { convertToCurrency } from "utils/stringServices";
import { useQueryClient } from "react-query";

export { TransferHome, Beneficiary, NewAccount, TransferHistory };

const TransferContainer = () => {
  return (
    <div className={styles.root}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ marginBottom: "22px" }}>
          <Text variant="xl" style={{ fontWeight: 600 }}>
            International Transfer
          </Text>
          <Text color="secondary" variant="sm">
            Transfer money to your loved ones globally
          </Text>
        </div>
        <Header hidden />
      </div>
      <MoneyCards />
      <Outlet />
    </div>
  );
};

export const MoneyCards = () => {
  const [transaction, setTransaction] = useState("345");
  const { data: walletBal } = useGetWalletBalance();
  const queryClient = useQueryClient();
  const onRefreshHandler = (cb) => {
    queryClient.invalidateQueries("wallet-balance");
    setTimeout(() => {
      cb?.();
    }, 3000);
  };
  return (
    <>
      <Hidden smDown>
        <div className={styles.cards}>
          <MoneyCard
            background="#21c06b1a"
            symbol="₦"
            currency="Naira Balance"
            amount={convertToCurrency(walletBal?.data?.ngn || 0)}
            variant="lg"
            onRefresh={onRefreshHandler}
          />
          <MoneyCard
            background="#0169FF1a"
            symbol="$"
            currency="Dollar Balance"
            amount={convertToCurrency(walletBal?.data?.usd || 0)}
            variant="lg"
            onRefresh={onRefreshHandler}
          />
          <MoneyCard
            background="#E2E8F0"
            symbol="€"
            currency="Euro Balance"
            amount={convertToCurrency(walletBal?.data?.eur || 0)}
            variant="lg"
            onRefresh={onRefreshHandler}
          />
        </div>
      </Hidden>
      <Hidden smUp>
        <div className={styles.cards}>
          <MoneyCard
            background="#21c06b1a"
            symbol="₦"
            currency="Naira Balance"
            amount={convertToCurrency(walletBal?.data?.ngn || 0)}
            refresh="col"
            onRefresh={onRefreshHandler}
          />
          <MoneyCard
            background="#0169FF1a"
            symbol="$"
            currency="Dollar Balance"
            amount={convertToCurrency(walletBal?.data?.usd || 0)}
            refresh="col"
            onRefresh={onRefreshHandler}
          />
          <MoneyCard
            background="#E2E8F0"
            symbol="€"
            currency="Euro Balance"
            amount={convertToCurrency(walletBal?.data?.eur || 0)}
            refresh="col"
            onRefresh={onRefreshHandler}
          />
        </div>
      </Hidden>
    </>
  );
};
export default TransferContainer;
